import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ValidationErrorService } from 'src/app/core/services/error/validation-error/validation-error.service';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { passwordMinLength } from 'src/app/shared/validators/registration-validators';

@Component({
  selector: 'app-form-feedback-list',
  templateUrl: './form-feedback-list.component.html',
  styleUrls: ['./form-feedback-list.component.scss'],
})
/**
 * Friendly form errors feedback
 */
export class FormFeedbackListComponent implements OnInit {
  validators?: string[];
  translatedValidators: { [index: string]: string } = {};
  passwordRequiresLabel = 'password-requires-label';
  @Input() abstractControl?: AbstractControl | null;

  /**
   * @constructor
   */
  constructor(
    private validationErrorService: ValidationErrorService,
    private translationService: TranslationService
  ) {}

  /**
   * on init
   */
  ngOnInit() {
    if (this.abstractControl) {
      this.validators = this.validationErrorService.getValidators(
        this.abstractControl
      );
    }
    if (this.validators) {
      this.validators = this.validators.filter(
        (validator) => validator !== 'required'
      );
      this.validators.forEach((validator) => {
        this.translatedValidators[validator] = `${validator}-feedback`;
      });
      this.translationService.translateObject(this.translatedValidators, {
        'invalid-password-too-short': {
          'min-length': passwordMinLength,
        },
      });

      this.translationService
        .translateString(this.passwordRequiresLabel)
        .then((translation) => {
          this.passwordRequiresLabel = translation;
        });
    }
  }

  /**
   * Retrieves abstract control errors if any
   */
  get abstractControlErrors() {
    return this.abstractControl?.errors;
  }

  /**
   * If some validator is failing
   * @param {string} validator}
   * @return {boolean}
   */
  isFailing(validator: string): boolean {
    if (this.abstractControlErrors) {
      return Object.keys(this.abstractControlErrors).includes(validator);
    } else {
      return false;
    }
  }
}
